import React from 'react';

const VideoLeft = (props) => (
    <svg width={18} height={18} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m12.15 9-4.894 3.169V5.83L12.15 9zm-9.563 6.412c.225.225.488.338.788.338H10.5a3.75 3.75 0 0 1 5.25-5.25V3.375c0-.3-.113-.563-.338-.788a1.08 1.08 0 0 0-.787-.337H3.375c-.3 0-.563.112-.788.337a1.08 1.08 0 0 0-.337.788v11.25c0 .3.112.563.337.787z"
            fill="#A9B1B9"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.5 10.5a3.001 3.001 0 0 0 0 6 3.001 3.001 0 0 0 0-6zm.3 5.1h-.6V15h.6v.6zm.621-2.325-.27.276c-.216.219-.351.399-.351.849h-.6v-.15c0-.33.135-.63.351-.849l.372-.378a.587.587 0 0 0 .177-.423c0-.33-.27-.6-.6-.6-.33 0-.6.27-.6.6h-.6a1.2 1.2 0 1 1 2.4 0 .955.955 0 0 1-.279.675z"
            fill="#007E45"
        />
    </svg>
);

export default VideoLeft;
